import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaders: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShaders"><Path d="M11.5092 3.5C10.4947 11.7608 18.828 7.37848 20.4998 14.5" stroke="currentColor"/><Path d="M3.5 13.1642C8.88462 8.7422 8.71274 12.6614 11.5769 14.901C13.7697 16.6156 16.9615 16.0207 17.5 20.4999" stroke="currentColor"/><Path d="M3.5 16.265C4.32051 15.7944 5.36743 15.3333 6.57692 15.5591C8.58963 15.9349 9.03846 19.0884 11.5 20.5" stroke="currentColor"/><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconShaders;
